<template>
  <div class="shop">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-1">Shop</h1>        
        </div>
      </div>
    </div>
    <div class="container shop-main has-text-centered">

      <br/>
      <br/>
      <p class="is-size-4">We're opening the Wild Axe Shop in a new tab for you.</p>
      <br/>
      <br/>
      <p><a @click="openShop">Click here</a> if it doesn't open automatically.</p>
      <br/>
      <br/>

    </div>
  </div>
</template>

<style lang="scss" scoped>
  .hero {
    background-color: black;
  }
  .shop-main {
    color: white;
    font-family: Verdana;
    height: 1000px;
  }
  p {
      color: white !important;
  }
</style>

<script>
export default {
name: 'shop',
  components : {
  },
  computed: {
  },
  data () {
      return {
      }
  },
  methods:{
      openShop: function () {
        //
        //
        window.open("http://wildaxe.com/lumberjack/wildaxeshop/");
        //
        //
      }
  },
  mounted(){
    setTimeout(() => {
      this.openShop();
    }, 3000);
  }
}
</script>
